module.exports = __webpack_public_path__ + "img/icon_yezza_qr.4f43764f.png";